<template>
  <div>
    <div class="text-h5 mt-5 mb-5">
      <v-btn color="success" v-if="selected.length > 0" @click="batch">
        <v-icon left>{{ mdiCheckCircleOutline }}</v-icon> Batch Items
      </v-btn> Stock Items
    </div>
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="stockItems"
      class="elevation-1"
      :loading="isLoading"
      :search="search"
      sort-by="deliveryNote.receivingDate"
      :sort-desc="true"
      item-key="id"
      show-select
      data-cy="table-stock-item"
    >
      <template v-slot:top>
        <v-toolbar
          flat
        >
          <v-btn
            v-if="selected.length > 0"
            color="success"
            class="mr-2"
            data-cy="StockItem-button-selected"
            @click="mergeStockItems"
          >
            <v-icon class="mr-2">{{ mdiFactory }}</v-icon>
            {{ $$t('btnSelected') }}
          </v-btn>
          <v-btn
            color="success"
            data-cy="StockItem-button-new"
            :to="{
              name: 'processing-EditDeliveryNote'
            }"
          >
            {{ $$t('new') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            :append-icon="mdiMagnify"
            :label="$t('common.search')"
            single-line
            hide-details
          ></v-text-field>
        </v-toolbar>
      </template>
      <template v-slot:item.sizeRange="{ item }">
        {{ item.sizeMin }} - {{ item.sizeMax }}
      </template>
      <template v-slot:item.deliveryNote.receivingDate="{ item }">
        {{ formatDateTime(item.deliveryNote.receivingDate) }}
      </template>
      <template v-slot:item.actions="{ item }">
        <!-- <v-btn color="success" :to="{
          name: 'processing-StockItemFiles',
          query: { stockItemId: item.id }
        }">
          <v-icon>{{ mdiContentSave }}</v-icon>
        </v-btn> -->
        <v-btn
            v-if="item.state === 'Received'"
            class="mr-2"
            small
            color="success"
            data-cy="StockItem-button-newCultivated"
            :to="{
              name: 'processing-EditReceivingOfCultivatedAbolone',
              query: { stockItemId: item.id },
            }"
          >
            Receive Cultivated Abalone
          </v-btn>
        <v-btn
          v-if="item.state === 'Receipted'"
          :data-cy="`StockItem-button-process-${index}`"
          small
          color="success"
          @click="processStockItem(item)"
        >
          <v-icon class="mr-2">{{ mdiFactory }}</v-icon>
          Process
        </v-btn>
        <!-- <v-btn
          color="primary"
          class="mr-2 ml-2"
          small
          :data-cy="`button-StockItem-edit-${item.id}`"
          :to="{
            name: 'processing-EditStockItem',
            query: {id: item.id}
          }"
          >
          <v-icon class="mr-2">
            {{ mdiPencil }}
          </v-icon>
          Edit
        </v-btn>
        <v-btn
          color="error"
          class="mr-2 ml-2"
          small
          :data-cy="`button-StockItem-remove-${item.id}`"
          @click="remove(item)"
          >
          <v-icon class="mr-2">
            {{ mdiDelete }}
          </v-icon>
          Delete
        </v-btn> -->
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import {
  mdiContentSave, mdiPencil, mdiDelete, mdiMagnify, mdiFactory,
} from '@mdi/js';
import dayjs from 'dayjs';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'ListStockItem',
  module: 'StockItem',
  mixins: [loading],
  data() {
    return {
      mdiContentSave,
      mdiPencil,
      mdiDelete,
      mdiFactory,
      mdiMagnify,
      search: '',
      selected: [],
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('stockItems', ['stockItems']),
    /**
    * Get table column headers
    */
    headers() {
      return [
        {
          text: this.$$t('farmId'),
          value: 'deliveryNote.farm.name',
        },
        {
          text: this.$$t('receivingDate'),
          value: 'deliveryNote.receivingDate',
        },
        {
          text: this.$$t('stockType'),
          value: 'stockType',
        },
        {
          text: this.$$t('receivedMass'),
          value: 'receivedMass',
        },
        {
          text: this.$$t('packedMass'),
          value: 'packedMass',
        },
        {
          text: this.$$t('sizeRange'),
          value: 'sizeRange',
        },
        {
          text: this.$$t('packedMass'),
          value: 'packedMass',
        },
        {
          text: this.$$t('quantity'),
          value: 'quantity',
        },
        {
          text: '',
          value: 'actions',
        },
      ];
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.LOAD_availableStockItems();
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('stockItems', ['LOAD_availableStockItems', 'DELETE_stockItem', 'UPDATE_stockItem', 'MERGE_stockItems']),
    async mergeStockItems() {
      const result = await this.$confirm('Are you sure you want to merge these items?');
      if (result) {
        this.isLoading = true;
        const { selected } = this;
        const mergeStockItemModel = selected.map((s) => s.id);
        console.log(selected);
        await this.MERGE_stockItems({ stockItemIds: mergeStockItemModel });
        await this.$nextTick();
        await this.LOAD_availableStockItems();
        this.isLoading = false;
      }
    },
    async processStockItem(stockItem) {
      this.isLoading = true;
      const { id } = stockItem;
      await this.UPDATE_stockItem({
        id,
        state: 'Processing',
        productionDate: dayjs(new Date()).add(1, 'day').toDate(),
      });
      await this.LOAD_availableStockItems();
      this.isLoading = false;
    },
    /** Delete StockItem from the collection
     */
    async remove(StockItem) {
      const result = await this.$confirm(this.$t('common.phrases.confirmDelete'));
      if (result) {
        this.isLoading = true;
        await this.DELETE_stockItem(StockItem.id);
        this.isLoading = false;
      }
    },
  },
};
</script>

<docs>
# StockItem example

'''js
<StockItem />
'''
</docs>
